// extracted by mini-css-extract-plugin
module.exports = {"grid":"EntityTable_grid__CvlDW"};